import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Date-map",
  "use": "icon-Date-map-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"icon-Date-map\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.667 1.468A.667.667 0 0 0 4 2.135v1.333H2a.667.667 0 0 0-.667.667v9.333c0 .368.299.667.667.667h12a.667.667 0 0 0 .667-.667V4.135A.667.667 0 0 0 14 3.468h-2V2.135a.667.667 0 0 0-1.333 0v1.333H5.334V2.135a.667.667 0 0 0-.667-.667Zm-2 11.333v-8h10.666v8H2.668Zm4.667-6a.667.667 0 0 1 0 1.334H4.667a.667.667 0 1 1 0-1.334h2.667Z\" fill=\"#7F8596\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol